import { faChevronRight } from "@jewlr/pro-light-svg-icons/faChevronRight"
import { Link } from "react-router-dom"

import {
  sizeChart as getSizeChart,
  averageRingSize as getAverageRingSize,
} from "areas/info/jewlr/ring-sizing/data"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { cn } from "styles/utils"

const SizeChart = () => {
  const sizeChart = getSizeChart()
  const averageRingSize = getAverageRingSize()
  return (
    <>
      <div className="mb-16 overflow-x-auto">
        <table
          aria-label="Ring sizing chart"
          className="border-collapse whitespace-nowrap"
        >
          <thead>
            <tr className="border-b-grey-20 border-b">
              <th
                className={cn(
                  "bg-white p-6 text-left",
                  "sticky left-0",
                  "font-bold"
                )}
              >
                Ring Size
              </th>
              {sizeChart.map((size) => (
                <th
                  className="p-6 text-center font-light"
                  key={`size-${size.size}`}
                >
                  {size.size}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <th className="sticky left-0 bg-white p-6 text-left">
                <div className="font-bold">Diameter (MM)</div>
                <span className="font-normal">Distance across</span>
              </th>
              {sizeChart.map((size) => (
                <td
                  className="p-6 text-center font-light"
                  key={`diameter-${size.diameter}`}
                >
                  {size.diameter}
                </td>
              ))}
            </tr>
            <tr>
              <th className="sticky left-0 bg-white p-6 text-left">
                <div className="font-bold">Circumference (MM)</div>
                <span className="font-normal">Distance around</span>
              </th>
              {sizeChart.map((size) => (
                <td
                  className="p-6 text-center font-light"
                  key={`circumference-${size.circumference}`}
                >
                  {size.circumference}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
      <p className="body-sm">
        The average ring size for women is size {averageRingSize.women}; the
        average ring size for men is size {averageRingSize.men}.
      </p>
      <p className="body-sm mb-24">
        A ring should fit secure enough so that it will never fall off. It
        should have a loose comfortable fit when sliding it over your knuckle.
      </p>
      <Button asChild text variant="secondary">
        <Link data-lc="size-guide" to="/info/ring_sizing">
          Read our full resizing policy{" "}
          <FontAwesomeIcon className="text-14 ml-4" icon={faChevronRight} />
        </Link>
      </Button>
    </>
  )
}

export default SizeChart
